import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
    const { data, error } = await supabase.from('lessons').select();

    if (error) {
      throw new Error('Failed to fetch data')
    }
    return data;
  }

  export async function getDataWithClass(cls) {
    const { data, error } = await supabase.from('lessons').select().eq('class',cls);

    if (error) {
      throw new Error('Failed to fetch data')
    }
    return data;
  }

  
  export async function getIdData(id) {
    const { data, error } = await supabase.from('lessons').select()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const { data, error } = await supabase.from('lessons').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    //console.log("udata",udata);
    const { data, error } = await supabase.from('lessons').update(udata).eq('id', udata.id).select();
    console.log("error",error,data);
    if (error) {

      throw new Error('Failed to fetch data')

    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('lessons').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }
